import {useState} from "react";

export enum ErrorDialogType {
    ERROR,
    WARNING,
    NONE,
}


export const useErrorDialog = () => {
    const [errorDialogType, setErrorDialogType] = useState(ErrorDialogType.ERROR);
    const [textErrorMessageDialog, setTextErrorMessageDialog] = useState("");
    const [textDetailErrorMessageDialog, setTextDetailErrorMessageDialog] = useState("");
    const [openErrorMessageDialog, setOpenErrorMessageDialog] = useState(false);
    const [onClose, setOnClose] = useState<() => void>(() => {
        return () => {
            setOpenErrorMessageDialog(false);
        }
    });

    return {
        textErrorMessageDialog, setTextErrorMessageDialog,
        textDetailErrorMessageDialog, setTextDetailErrorMessageDialog,
        errorDialogType, setErrorDialogType,
        openErrorMessageDialog, setOpenErrorMessageDialog,
        onClose, setOnClose,
        show: (message: string, details: string = "", type: ErrorDialogType = ErrorDialogType.ERROR) => {
            setTextErrorMessageDialog(message);
            setTextDetailErrorMessageDialog(details);
            setErrorDialogType(type);
            setOpenErrorMessageDialog(true);
        },
        hide: () => {
            setTextErrorMessageDialog("");
            setTextDetailErrorMessageDialog("");
            setOpenErrorMessageDialog(false);
        }


    };
}
